// Recovered compiled webpack factory 44807. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { V: () => a });
  var n = i(37822),
    s = i(92419),
    r = i(9150),
    o = i(23919);
  let a = {
    test: (0, o.$)("hsl", "hue"),
    parse: (0, o.q)("hue", "saturation", "lightness"),
    transform: ({ hue: t, saturation: e, lightness: i, alpha: o = 1 }) =>
      "hsla(" +
      Math.round(t) +
      ", " +
      s.KN.transform((0, r.a)(e)) +
      ", " +
      s.KN.transform((0, r.a)(i)) +
      ", " +
      (0, r.a)(n.X4.transform(o)) +
      ")",
  };
}
